import Container from '@/components/layout/Container';
import Image from 'next/image';
import Link from 'next/link';
import CleanhubScript from './CleanhubScript';

export default async function Cleanhub({ block, position }) {
  const {
    title,
    description_rte,
    _metadata,
    background_image,
    link_text,
    link,
    background_overlay_on,
    background_overlay_color
  } = block.cleanhub_widget;

  return (
    <section
      id={_metadata.uid + '_' + position}
      data-name="cleanhub"
      className={`relative h-full bg-cover bg-center bg-no-repeat py-20 text-white sm:py-[120px] ${background_overlay_on ? `bg-[${background_overlay_color}]` : ''}`}
    >
      <div
        className={`absolute top-0 left-0 h-full w-full ${background_overlay_on ? `z-10 opacity-70` : ''}`}
      >
        {background_image?.url && (
          <Image
            src={background_image.url}
            alt={background_image.title.replace(/\.[^/.]+$/, '')}
            fill
            sizes="100vw"
            className="absolute top-0 left-0 z-0 object-cover"
          />
        )}
      </div>
      <div className="relative z-30">
        <Container>
          <h2 className="h3 lg:h2 mb-10 text-center">{title}</h2>
          <CleanhubScript />
          <div
            className="rte-simple body-r mb-10 text-center"
            dangerouslySetInnerHTML={{ __html: description_rte }}
          />

          {link && (
            <div className="text-center">
              <Link
                href={link}
                title="Leesa's Cleanhub impact report"
                className="txt-btn-secondary-white body-r pb-1"
                prefetch={false}
              >
                {link_text}
              </Link>
            </div>
          )}
        </Container>
      </div>
    </section>
  );
}
